import { MetaDataNextSEO } from 'components/MetaDataNextSEO/MetaDataNextSEO';
import ClientNotFoundPage from 'components/PageLevelComponents/ClientNotFoundPage';
import { LOCALE_DEFAULT } from 'config/config';
import { FC } from 'react';
import { INotFoundPageResource } from 'server/resource/page/notFoundPageResource';
import { LocalizationService } from '@/service/localization/localizationService';
import { ErrorPageDataService } from '@/service/data/errorPageDataService';

const NotFoundPage: FC<INotFoundPageResource> = ({ locale, errorData, metaData }) => {
  return (
    <>
      {metaData && <MetaDataNextSEO metaData={metaData} locale={locale} />}
      <ClientNotFoundPage locale={locale} errorData={errorData} errorType="404" />
    </>
  );
};

// This also gets called at build time
export const getStaticProps = async ({ locale }: { locale: string }) => {
  const market = LocalizationService.getMarket(locale ?? LOCALE_DEFAULT);
  const data = await ErrorPageDataService.getData('404', market);

  return {
    props: {
      locale,
      errorData: data,
      metaData: {
        title: data?.title || 'Page Not Found',
      },
    },
  };
};

export default NotFoundPage;
